import React from "react";
import { Box, Container, Typography } from "@mui/material";
import Page from "../../components/Page";
import { ATTICUS_PAGE_PREFIX, SCREEN_PATHS } from "../../constants";

// documentation: https://github.com/TheAtticusApp/atticus-app/wiki/Maintenance-mode
export const MaintenanceView = (): JSX.Element => {
  return (
    <Page title={`${ATTICUS_PAGE_PREFIX} - Maintenance Mode`}>
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Container maxWidth="sm">
          <Typography align="center" color="textPrimary" variant="h1">
            Atticus is currently under maintenance.
          </Typography>
          <br />
          <Typography align="center" color="textPrimary" variant="subtitle2">
            Maintenance is usually completed in an hour or less. <br />
            Please come back later and{" "}
            <a href={SCREEN_PATHS.auth}>try signing in</a>.
          </Typography>
        </Container>
      </Box>
    </Page>
  );
};
